import SharedModal from '../Modal/SharedModal';

//Sources
import AboutSourcesGda from './AboutSections/AboutSourcesGda';
import AboutSourcesVda from './AboutSections/AboutSourcesVda';
import AboutSourcesDda from './AboutSections/AboutSourcesDda.tsx';

//Metrics
import AboutMetricsGdaScore from './AboutSections/Metrics/AboutMetricsGdaScore.tsx';
import AboutMetricsVdaScore from './AboutSections/Metrics/AboutMetricsVdaScore.tsx';
import AboutMetricsSpecificity from './AboutSections/Metrics/AboutMetricsSpecificity.tsx';
import AboutMetricsPleiotropy from './AboutSections/Metrics/AboutMetricsPleiotropy.tsx';
import AboutMetricsEvidenceIndex from './AboutSections/Metrics/AboutMetricsEvidenceIndex.tsx';

//Diseases
import DiseaseType from './AboutSections/Attributes/Diseases/DiseaseType';
import DO from './AboutSections/Attributes/Diseases/DO';
import MeSHDiseaseClass from './AboutSections/Attributes/Diseases/MeSHDiseaseClass';
import HPO from './AboutSections/Attributes/Diseases/HPO';

//Gene Disease
import FirstRef from './AboutSections/Attributes/GeneDisease/FirstRef';
import LastRef from './AboutSections/Attributes/GeneDisease/LastRef';
import OriginalDB from './AboutSections/Attributes/GeneDisease/OriginalDB';
import EvidenceLevel from './AboutSections/Attributes/GeneDisease/EvidenceLevel';

//Genes
import GenespLI from './AboutSections/Attributes/Genes/GenespLI';
import GenesProteinClass from './AboutSections/Attributes/Genes/GenesProteinClass';
import GenesUniProt from './AboutSections/Attributes/Genes/GenesUniProt';

//Variants
import Position from './AboutSections/Attributes/Variants/Position';
import Type from './AboutSections/Attributes/Variants/Type';
import RiskAllele from './AboutSections/Attributes/Variants/RiskAllele';
import Consequence from './AboutSections/Attributes/Variants/Consequence';
import Alleles from './AboutSections/Attributes/Variants/Alleles';
import GenomeExome from './AboutSections/Attributes/Variants/Genome-Exome';
import Hgvsc from './AboutSections/Attributes/Variants/Hgvsc';
import Hgvsp from './AboutSections/Attributes/Variants/Hgvsp';

//Variant Disease
import PMID from './AboutSections/Attributes/VarianDiseases/PMID';
import PValue from './AboutSections/Attributes/VarianDiseases/PValue';

function HelpPopups({
  // Sources
  showGDA,
  setShowGDA,
  showVDA,
  setShowVDA,
  showDDA,
  setShowDDA,

  // Metrics
  showScore,
  setShowScore,
  showDSI,
  setShowDSI,
  showDPI,
  setShowDPI,
  showEI,
  setShowEI,

  // Diseases
  showDiseaseType,
  setShowDiseaseType,
  showMeSH,
  setShowMeSH,
  showDO,
  setShowDO,
  showHPO,
  setShowHPO,
  showHgvsc,
  setShowHgvsc,
  showHgvsp,
  setShowHgvsp,

  // Genes
  showpLI,
  setShowpLI,
  showProteinClass,
  setShowProteinClass,
  showUniProt,
  setShowUniProt,

  // Variants
  showVariantPosition,
  setShowVariantPosition,
  showVariantType,
  setShowVariantType,
  showVariantRiskAllele,
  setShowVariantRiskAllele,
  showVariantConsequence,
  setShowVariantConsequence,
  showAlleles,
  setShowAlleles,
  showGenomeExome,
  setShowGenomeExome,

  // Gene-Disease Associations && Variant-Disease Associations
  showFirstRef,
  setShowFirstRef,
  showLastRef,
  setShowLastRef,
  showEvidenceLevel,
  setShowEvidenceLevel,
  showOriginalDB,
  setShowOriginalDB,
  showPMID,
  setShowPMID,
  showpValue,
  setShowpValue,
}) {
  return (
    <>
      {/* Sources */}

      <SharedModal
        open={showGDA}
        setOpen={setShowGDA}
        title="Gene-Disease Associations (GDA)"
        content={<AboutSourcesGda />}
      />

      <SharedModal
        open={showVDA}
        setOpen={setShowVDA}
        title="Variant-Disease Associations (VDA)"
        content={<AboutSourcesVda />}
      />

      <SharedModal
        open={showDDA}
        setOpen={setShowDDA}
        title="Drug-Disease Associations (DDA)"
        content={<AboutSourcesDda />}
      />

      {/* Metrics */}

      <SharedModal
        open={showScore}
        setOpen={setShowScore}
        title=""
        content={
          <>
            <AboutMetricsGdaScore />
            <AboutMetricsVdaScore />
          </>
        }
      />

      <SharedModal open={showDSI} setOpen={setShowDSI} title="" content={<AboutMetricsSpecificity />} />

      <SharedModal open={showDPI} setOpen={setShowDPI} title="" content={<AboutMetricsPleiotropy />} />

      <SharedModal open={showEI} setOpen={setShowEI} title="" content={<AboutMetricsEvidenceIndex />} />

      {/* Data Attributes Diseases */}

      <SharedModal
        open={showDiseaseType}
        setOpen={setShowDiseaseType}
        title="Disease Type"
        content={<DiseaseType />}
      />

      <SharedModal open={showDO} setOpen={setShowDO} title="Disease Ontology (DO)" content={<DO />} />

      <SharedModal
        open={showHPO}
        setOpen={setShowHPO}
        title="Human Phenotype Ontology (HPO)"
        content={<HPO />}
      />

      <SharedModal
        open={showMeSH}
        setOpen={setShowMeSH}
        title="MeSH Disease Class"
        content={<MeSHDiseaseClass />}
      />

      {/* Data Attributes Genes */}

      <SharedModal open={showpLI} setOpen={setShowpLI} title="pLI" content={<GenespLI />} />

      <SharedModal
        open={showProteinClass}
        setOpen={setShowProteinClass}
        title="Protein classification"
        content={<GenesProteinClass />}
      />

      <SharedModal open={showUniProt} setOpen={setShowUniProt} title="UniProt" content={<GenesUniProt />} />

      {/* Data Attributes Variants */}

      <SharedModal
        open={showVariantPosition}
        setOpen={setShowVariantPosition}
        title="Variant Position"
        content={<Position />}
      />

      <SharedModal
        open={showVariantType}
        setOpen={setShowVariantType}
        title="Variant Type"
        content={<Type />}
      />

      <SharedModal open={showAlleles} setOpen={setShowAlleles} title="Alleles" content={<Alleles />} />

      <SharedModal
        open={showVariantRiskAllele}
        setOpen={setShowVariantRiskAllele}
        title="Risk Allele"
        content={<RiskAllele />}
      />

      <SharedModal
        open={showVariantConsequence}
        setOpen={setShowVariantConsequence}
        title="Consequence Type"
        content={<Consequence />}
      />

      <SharedModal
        open={showGenomeExome}
        setOpen={setShowGenomeExome}
        title="AF Genomes - Exomes"
        content={<GenomeExome />}
      />

      <SharedModal
        open={showHgvsc}
        setOpen={setShowHgvsc}
        title={
          <>
            Hgvs <sub>c</sub>
          </>
        }
        content={<Hgvsc />}
      />

      <SharedModal
        open={showHgvsp}
        setOpen={setShowHgvsp}
        title={
          <>
            Hgvs <sub>p</sub>
          </>
        }
        content={<Hgvsp />}
      />

      {/* Data Attributes Gene-Disease Associations && Data Attributes Variant-Disease Associations */}

      <SharedModal
        open={showFirstRef}
        setOpen={setShowFirstRef}
        title="First Reference"
        content={<FirstRef />}
      />

      <SharedModal open={showLastRef} setOpen={setShowLastRef} title="Last Reference" content={<LastRef />} />

      <SharedModal
        open={showEvidenceLevel}
        setOpen={setShowEvidenceLevel}
        title="Evidence Level for the GDA"
        content={<EvidenceLevel />}
      />

      <SharedModal
        open={showOriginalDB}
        setOpen={setShowOriginalDB}
        title="Original Database"
        content={<OriginalDB />}
      />

      <SharedModal open={showPMID} setOpen={setShowPMID} title="PubMed Identifier" content={<PMID />} />

      <SharedModal
        open={showpValue}
        setOpen={setShowpValue}
        title="P-value of the GWAS"
        content={<PValue />}
      />
    </>
  );
}

export default HelpPopups;
